module.exports = __webpack_public_path__ + "img/items.398f651d.webp";